import ModelState from 'spa/state/_util/model';
import QS from 'querystring';

class WorkerReviewsState extends ModelState {
  get method() { return 'GET'; }
  get url() { return '/workers'; }
  get subUrl() { return 'reviews'; }
  get singular() { return 'reviews'; }
  get plural() { return 'reviews'; }


  getSearchRequest(search, ...params) {
    const [workerId] = params;

    if (!this.url) {
      throw new Error('Missing option `url`');
    }

    if (!this.subUrl) {
      throw new Error('Missing option `subUrl`');
    }

    if (!this.singular) {
      throw new Error('Missing option `singular`');
    }

    return this.ctx.sdk.get(`${this.url}/${workerId}/${this.subUrl}?${QS.stringify(search.search)}`);
  }
}

export default WorkerReviewsState;



// WEBPACK FOOTER //
// ./spa/state/worker-reviews.jsx